import { useCallback } from "react";
import { useAtomValue } from "jotai";
import { useRouter } from "next/navigation";
import { Button } from "@zapier/design-system-beta";
import { canvasNameAtom } from "@zapier/canvas-state";
import { BannerWrapper } from "../../BannerWrapper";

export function LoggedOutTemplateBanner() {
  const router = useRouter();
  const canvasName = useAtomValue(canvasNameAtom);

  const handleLogInToUseThisTemplate = useCallback(() => {
    router.push(`/app/login?next=${window.location.pathname}`);
  }, [router]);

  const title = `You are previewing the template '${canvasName}'`;
  const description =
    "Log in to use this template and create the Zapier assets displayed below.";

  return (
    <BannerWrapper title={title} description={description}>
      <Button onPress={handleLogInToUseThisTemplate}>Log in</Button>
    </BannerWrapper>
  );
}
